import { Environment } from '@shared/utils/constants';
export const isNonProd = (env)=>{
    return env === Environment.Development;
};
export const DEBUG_STATE = isNonProd(process.env.APP_ENV);
